var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.983 57.3115C45.983 57.3115 52.0322 44.6059 60.323 43.2487",
    stroke: "#311806",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9837 28.6883C45.9837 28.6883 54.4527 43.0823 60.2679 43.1387",
    stroke: "#311806",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2764 43.1357L60.212 43.1357",
    stroke: "#311806",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 84.6998C19.7697 84.6998 1.1 66.0301 1.1 42.9998C1.1 19.9695 19.7697 1.2998 42.8 1.2998C65.8303 1.2998 84.5 19.9695 84.5 42.9998C84.5 66.0301 65.8303 84.6998 42.8 84.6998Z",
    stroke: "#311806"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.74af68c054329c11d2af08f3bcdca2b5.svg";
export { ForwardRef as ReactComponent };